import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { CheckSideBarAction, MobileSidebarSideBarAction } from '../../Redux/Action';
import { useNavigate } from "react-router-dom";

import {
    Routes,
    Route,
    Link,
    Navigate,
  } from 'react-router-dom';

function Header() {
    useEffect(() => {
        document.title = 'Safexpay Docs';
      }, []);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { CheckSidebarOpen, CheckMobileSidebarOpen } = useSelector((state) => {
        return {
            CheckSidebarOpen: state.Header.CheckSidebarOpen,
            CheckMobileSidebarOpen: state.Header.CheckMobileSidebarOpen,
        }
    });

    useEffect(() => {
        console.log("CheckSidebarOpen :-", CheckSidebarOpen)
    }, [CheckSidebarOpen])

    const onClickPaymentGateway = () => {
        dispatch(CheckSideBarAction(true))
        sessionStorage.setItem('CheckSidebarOpen', true);
        return navigate('/Overview', { replace: true }); ///  Payment Gateway
    }
    const onClickNeoBanking = () => {
        dispatch(CheckSideBarAction(false))
        sessionStorage.setItem('CheckSidebarOpen', false);
        return navigate('/Introduction', { replace: true });  /// Neo Banking
    }
    const onClickAPIX = () => {
        dispatch(CheckSideBarAction('APIX'))
        sessionStorage.setItem('CheckSidebarOpen', 'APIX');
        return navigate('/Apix', { replace: true });  /// APIX
    }
    const onClickToggleMobileSidebar = () => {
        dispatch(MobileSidebarSideBarAction(!CheckMobileSidebarOpen))
    }

    useEffect(() => {
        if (window.performance) {
            if (performance.navigation.type == 1) {
                // alert("This page is reloaded :-"+sessionStorage.getItem('CheckSidebarOpen'));
                if (sessionStorage.getItem('CheckSidebarOpen') == 'true') {
                    dispatch(CheckSideBarAction(true))
                } else if(sessionStorage.getItem('CheckSidebarOpen') == 'APIX') {
                    dispatch(CheckSideBarAction('APIX'))
                } else {
                    dispatch(CheckSideBarAction(false))
                }
            } else {
                // alert("This page is not reloaded");
            }
        }
    }, [])

    return (
        <><header id="header" className="sticky-top">
            <nav className="primary-menu navbar navbar-expand-lg navbar-dropdown-dark">
                <div className="container-fluid">
                    <button id="sidebarCollapse" className="navbar-toggler d-block d-md-none" type="button" onClick={onClickToggleMobileSidebar}>
                        <span></span>
                        <span className="w-75"></span>
                        <span className="w-50"></span></button>
                    <a className="logo ml-md-3" href="index.html" title="iDocs Template" style={{ marginLeft: "0px !important" }}>
                        <img src="assets/images/logo.png" alt="iDocs Template" />
                    </a>
                    <input type="text" id="myInput" style={{ marginLeft: "-32px", width:"20%" }} placeholder="Search Documentation" title="Type in a name"></input>
                    <button className="navbar-toggler ml-auto" type="button" data-toggle="collapse" data-target="#header-nav">
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                    <div id="header-nav" className="collapse navbar-collapse justify-content-end">
                        <ul className="navbar-nav mlr-auto">
                            <li ><a><span style={{ cursor:"pointer"}} className={CheckSidebarOpen == true && 'ActiveHeaderTabStyle'} onClick={onClickPaymentGateway}>Payment Gateway</span></a></li>
                            <li><a><span style={{ cursor:"pointer"}} className={CheckSidebarOpen == false ? 'ActiveHeaderTabStyle ml-2 mr-2' : 'ml-2 mr-2'} onClick={onClickNeoBanking} >Neo Banking</span></a></li>
                            <li><a><span style={{ cursor:"pointer"}} className={CheckSidebarOpen == "APIX" ? 'ActiveHeaderTabStyle ml-2 mr-2' : 'ml-2 mr-2'} onClick={onClickAPIX} >APIX</span></a></li>
                            <li><a href="https://testapi.aasaancheckout.com/api-docs/"><span style={{ cursor:"pointer"}} className={'ml-2 mr-2'} >Aasaan</span></a></li>
                        </ul>
                    </div>
                    <a target="_blank">Log In</a>
                    <a className="btn-support nav-link">Sign Up</a>
                </div>   
            </nav>
        </header>
            {/* <div style={{ marginLeft: 0, padding: 0 }}>
                <img src={process.env.PUBLIC_URL + '/images/Arrow-Green.png'} alt="logo" style={{
                    width: "21%",
                    float: "right", top: "5%", right: "20%", position: "absolute"
                }} />
            </div> */}
        </>
    )
}

export default Header